import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { JSONApiDataObject, ReduxEntity } from 'Douleutaras/types';
import { BsdirGalleryItem } from 'Douleutaras/types/bsdir';
import { RootState } from 'Douleutaras/redux/store';

const bsdirGalleryItemsAdapter = createEntityAdapter<JSONApiDataObject<BsdirGalleryItem>>({
  selectId: item => item.id
});

export const bsdirGalleryItemsSlice = createSlice({
  name: 'bsdirGalleryItems',
  initialState: bsdirGalleryItemsAdapter.getInitialState({
    loading: false,
    error: false,
    meta: {},
    entities: {}
  } as ReduxEntity<BsdirGalleryItem>),
  reducers: {
    bsdirGalleryItemsAdded: (state, action) => {
      bsdirGalleryItemsAdapter.setMany(state, action.payload);
    }
  }
});

export const bsdirGalleryItemsSelectors = bsdirGalleryItemsAdapter.getSelectors(
  (state: RootState) => state.bsdir.galleryItems);
export default bsdirGalleryItemsSlice.reducer;
